
import React, { Component, Fragment, useEffect, useState, useContext } from "react";
import { SessionContext } from "../../../context/SessionProvider";

import useFetch from "../../helpers/useFetch";
import BiButton from "../../uic/controls/BiButton";
import BiLabel from "../../uic/controls/BiLabel";
import BiDataGrid from "../../uic/dataGrid/BiDataGrid"
import { useNavigate } from 'react-router-dom';
import StatusObrazca from "../Obrazci/StatusObrazca";
import BiComboBox from "../../uic/controls/BiComboBox";
import authService from '../../api-authorization/AuthorizeService'
import { httpGet } from "../../helpers/httpHelper";
const ObrazciStranka = (props) => {
    const navigate = useNavigate();

    const { sessionReady, sessionData,setLoading, toastError, toastOK, setHelpMainKey } = useContext(SessionContext)
    const { data: obrazci, setUrl: setObrazciURL, isLoaded } = useFetch(null);
    const { data: tipobrazca, setUrl: setUrlTipObrazca } = useFetch(null, true);

    useEffect(() => {
        if (sessionReady) {
            setLoading(true);
            setObrazciURL('api/obrazci/GetObrazciStranka');
            setUrlTipObrazca('api/sifranti/GetSifrantNA?all=true&ID=TIPOBRAZCA');
        }
    }, [sessionReady])
    useEffect(() => { setLoading(false); }, [isLoaded]);
    const [izbranObrazec, setIzbranObrazec] = useState(null);

    const formDataChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));

    }

    const [formData, setFormData] = useState({
        tipobrazca: {
            naziv: "",
            id: null
        },
        leto: 2026 //new Date().getFullYear()
    });

    const statusObrazca = (col, item) => {

        return <StatusObrazca status={item.pIdStatus} ></StatusObrazca>

    }

    const gumbIzpolni = (col, item) => {
        return <BiButton icon="fas fa-pen-to-square " onClick={()=>odpriObrazec(item)} >Odpri obrazec</BiButton>
    }

    const odpriObrazec = (obrazec) => {
        console.log(obrazec);
        navigate('/UrejanjeObrazcaStranka', { replace: false, state: { pIdObrazca: obrazec.pIdObrazca } });
    

    }

    const dodajObrazec = () => {
        //DodajObrazec

        setLoading(true);
        if (formData.tipobrazca.id != null) {
            httpGet(
                "api/obrazci/DodajObrazec",
                {
                    IdStranke: sessionData.stranka.idStranke,
                    PIdTipObrazca: formData.tipobrazca.id
                },
                (ret) => {
                    //setObrazciURL('api/obrazci/GetObrazciStranka?time=' + new Date().toISOString());
                    odpriObrazec(ret.obrazec)
                    setLoading(false);
                },
                authService);
        }
        else {
            setLoading(false);
            return "Izberite tip obrazca, ki ga želite oddati."
        }
    }

    return (

        <Fragment >
            {obrazci && 
                <Fragment>

                    <h2 id="tabelLabel" >Seznam vseh obrazcev</h2>
                    <p>Na seznamu so vsi obrazci za tekoče leto.</p>
                    {sessionData && sessionData.strankaEKO == true && 
                       
                        <Fragment>
                            <span style={{ marginRight: "6px", fontSize: "14px", marginLeft: "20px" }}><i className="fa-brands fa-typo3" style={{ color: "gray", marginRight: "4px" }}></i>Tip obrazca: </span>
                            <BiComboBox
                                online={false}
                                items={tipobrazca}
                                width="200"
                                item={formData.tipobrazca}
                                onItemSelected={formDataChange}
                                name="tipobrazca">
                            </BiComboBox>
                            <span style={{ marginRight: "6px", fontSize: "14px", marginLeft: "2px" }}></span>
                            <BiButton icon="fas fa-plus-circle " onClick={() => dodajObrazec()} >Dodaj obrazec</BiButton>
                            <p style={{ margin: "4px" }}></p>
                        </Fragment>
                    }
                    <BiDataGrid
                        items={obrazci}
                        mainKey="pIdObrazca"
                        onSelectionChanged={(d) => setIzbranObrazec(d.pIdObrazca)}
                        columns={[
                            { label: "", key: "pIdStatus", type: "template", displayFunction: gumbIzpolni, width: "130px", cellStyle: { style: { padding: "0px" } } },
                            { label: "Stranka", key: "nazivStranke", type: "string", width: "200px" },
                            { label: "ID", key: "pIdObrazca", type: "decimal", width: "50px" },
                            { label: "Status", key: "pIdStatus", type: "template", displayFunction: statusObrazca, width: "120px" },
                            { label: "Opis", key: "tipKontrole", type: "string", width: "200px" },
                            { label: "Tip", key: "nazivObrazca", type: "string", width: "300px" },
                            { label: "Leto", key: "leto", type: "string", width: "80px" },
                            /*{ label: "", key: "pIdStatus", type: "template", displayFunction: gumbIzpolni, width: "130px", cellStyle: { style: { padding: "0px" } } },*/
                            { width: "100%" },
                        ]}

                    ></BiDataGrid>

                </Fragment>
            
            }
        </Fragment>   
    );

}

export default ObrazciStranka;